import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser'; 
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { environment } from './../environments/environment';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { TokenInterceptor } from './core/services/token.interceptor';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CourseCatalogModule } from './pages/course-catalog/course-catalog.module';
import { PeopleModule } from './pages/people/people.module';
import { SharedModule } from './shared/shared.module';
import { StyleGuideModule } from './pages/style-guide/style-guide.module';
import { FacilitiesModule } from './pages/facilities/facilities.module';
import { SaveChangesModalComponent } from './core/modals/save-changes/save-changes-modal.component';
import { TestModule } from './pages/test/test.module';
//These components were for the 2021 Teams addition
import { ChromelessComponent } from './pages/chromeless/chromeless.component';
import { NgxMasonryModule } from 'ngx-masonry';
import { ContentPageModule } from './pages/content-page/content-page.module';
import { DiagnoseComponent } from './pages/diagnose/diagnose.component';


@NgModule({
    bootstrap:
    [
        AppComponent
    ],
    declarations:
    [
        AppComponent,
        DashboardComponent,
        SaveChangesModalComponent,
        ChromelessComponent,
        DiagnoseComponent,
    ],
    exports: [],
    imports:
    [
        BrowserModule,
        RouterModule,
        NgbModule,
        CoreModule.forRoot(),
        SharedModule,
        BrowserAnimationsModule,
        // The other modules need to be imported so the IWidgetComponents may be listed as entryComponents
        PeopleModule,
        StyleGuideModule,
        CourseCatalogModule,
        FacilitiesModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            extendedTimeOut: 15000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            countDuplicates: true,
            progressBar: true,
        }),
        NgxMasonryModule,
        ContentPageModule,
        TestModule
    ],
    providers:
    [
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        NgbActiveModal,
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule {
    constructor() {
        if (!environment.production) {
            console.log(environment);
        }
    }
}
